export type { ResultGlassProps } from "./ResultGlass";
export { default, ResultType } from "./ResultGlass";
